export function createTimeElapsedCounter(offset = 0) {
  let startTime = Date.now()

  return function timeElapsed() {
    return offset + Math.floor((Date.now() - startTime) / 1000)
  }
}
